import { Chip, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Iconify from 'src/components/iconify';

export default function FilterChips({
  selectedFilters,
  setSelectedFilters,
  filters,
}) {
  // states
  const [showAll, setShowAll] = useState(false);

  return (
    <Stack direction="row" flexWrap="wrap" gap="8px" mb="12px">
      {selectedFilters
        .slice(0, showAll ? selectedFilters.length : 7)
        .map(filter => {
          const foundFilter = Object.keys(filters).map(key => {
            if (filters[key].find(item => item.code === filter)) {
              return filters[key].find(item => item.code === filter);
            }
            return null;
          });
          const chip = foundFilter.filter(item => item !== null)[0];

          return (
            <Chip
              key={chip.code}
              label={chip.name}
              clickable
              sx={{
                backgroundColor: theme =>
                  theme.palette.background.primaryAccent2,
                borderColor: theme => theme.palette.border.primaryAccent2,
                color: theme => theme.palette.content.accent1,
                '&:hover': {
                  backgroundColor: theme =>
                    theme.palette.background.primaryAccent2,
                },
              }}
              variant="outlined"
              onDelete={() => {
                setSelectedFilters(prevSelectedFilters =>
                  prevSelectedFilters.filter(item => item !== chip.code),
                );
              }}
            />
          );
        })}
      {selectedFilters.length > 7 && (
        <Chip
          key="see-more"
          label={`See ${showAll ? 'less' : 'more'}`}
          clickable
          sx={{
            backgroundColor: theme => theme.palette.background.primaryAccent2,
            borderColor: theme => theme.palette.border.primaryAccent2,
            color: theme => theme.palette.content.accent1,
            '&:hover': {
              backgroundColor: theme => theme.palette.background.primaryAccent2,
            },
          }}
          variant="outlined"
          deleteIcon={
            <Iconify icon={`tabler:chevron-${showAll ? 'up' : 'down'}`} />
          }
          onDelete={() => {
            setShowAll(prev => !prev);
          }}
        />
      )}
      {showAll}
    </Stack>
  );
}

FilterChips.propTypes = {
  selectedFilters: PropTypes.array,
  setSelectedFilters: PropTypes.func,
  filters: PropTypes.object,
};
